export default "-- ClickBench Q23\nselect *\nfrom hits\nwhere url like '%google%'\norder by eventtime \nlimit 10;";